<template>
  <div class="alarms-container">
    <div class="alarms">
      <div class="title">
        <span>Напоминания</span>
        <Button class="ml-1" @click="newAlarm()" icon="plus" />
      </div>
      <Alarm
        v-for="(alarm, index) in alarms"
        :class="{'mt-3': index != 0}"
        :key="alarm.id ? alarm.id : alarm.t_id"
        :alarm="alarm"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Alarm from "./Alarm.vue";
export default {
  props: ["alarms"],
  computed: {
    ...mapState("users", { user: "active" }),
  },
  components: { Alarm },
  data() {
    return {};
  },
  methods: {
    newAlarm() {
      this.alarms.push({
        t_id: Date.now(),
        zone: this.user.zone ? this.user.zone : 7,
        month_days: 0, //no days
        days: 127, //all days
        time: 12 * 60, //12:00
        enabled: true,
        greeting: "Осталось сделать:",
      });
    },
  },
};
</script>
<style lang="postcss">
.alarms-container {
  .alarms {
    .title {
      display: grid;
      grid-auto-flow: column;
      grid-template-columns: auto auto 1fr;
      grid-tempate-rows: 2em;
      align-items: center;

      span {
      }
    }
  }
}
</style>